import React from 'react';
import FadeUp from '../ui/FadeUp';

export default function Reviews() {
  const reviews = [
    { text: "Fast and affordable junk removal. Showed up on time and cleaned everything up. Highly recommend to anyone on the Shore who needs junk hauled away.", author: "Salisbury Homeowner" },
    { text: "Called in the morning and they were out the same afternoon. Cleared out my whole garage without any issues. Very professional and friendly team.", author: "Fruitland Resident" },
    { text: "Couldn't believe how easy this was. Fair price, they did all the work, and my yard looks amazing now. Will definitely use again.", author: "Ocean City Customer" },
  ];

  return (
    <section id="reviews" className="bg-dark-2 section-padding border-y border-dark-4">
      <FadeUp className="text-center max-w-[560px] mx-auto mb-14">
        <div className="font-condensed text-xs font-bold tracking-[0.2em] uppercase text-gold mb-4">Customer Reviews</div>
        <h2 className="font-condensed font-black text-[clamp(36px,4vw,56px)] uppercase leading-none mb-5 text-white">What Neighbors Say</h2>
        <p className="text-text-muted text-[18px] leading-relaxed font-medium">
          Real feedback from real homeowners across the Eastern Shore.
        </p>
      </FadeUp>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((review, i) => (
          <FadeUp key={i} delay={i * 0.1} className="bg-dark-3 border-2 border-dark-4 rounded-lg p-9">
            <div className="text-gold text-xl tracking-[3px] mb-5">★★★★★</div>
            <div className="text-[17px] leading-[1.7] text-text-muted italic mb-6 font-medium">"{review.text}"</div>
            <div className="text-[14px] font-bold uppercase tracking-[0.12em] text-text-muted">
              — <span className="text-gold">{review.author}</span>
            </div>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}